enum AppEnv {
  Development = 'development',
  Local = 'local',
  Production = 'production',
  Staging = 'staging',
}

const isAppEnv = (env: unknown): env is AppEnv => {
  return typeof env === 'string' && Object.values(AppEnv).includes(env as AppEnv)
}

const DAPP_URL_MAP = {
  development: 'dev-app.ethena.fi',
  local: 'localhost:3009',
  production: 'app.ethena.fi',
  staging: 'staging-app.ethena.fi',
}

const LANDING_URL_MAP = {
  development: 'dev-landing.ethena.fi',
  local: 'localhost:3000',
  production: 'ethena.fi',
  staging: 'staging-landing.ethena.fi',
}

const CLAIM_URL_MAP = {
  development: 'dev-claim.ethena.fi',
  local: 'localhost:3002',
  production: 'claim.ethena.fi',
  staging: 'staging-claim.ethena.fi',
}

const CALCULATOR_URL_MAP = {
  development: 'dev-calculator.ethena.fi',
  local: 'localhost:3001',
  production: 'ethena.vfat.io',
  staging: 'staging-calculator.ethena.fi',
}

const APP_ENV: AppEnv = isAppEnv(process.env.NEXT_PUBLIC_APP_ENV) ? process.env.NEXT_PUBLIC_APP_ENV : AppEnv.Production

export const SHORT_DAPP_URL = DAPP_URL_MAP[APP_ENV]
const HTTP_DAPP_URL = 'http://' + SHORT_DAPP_URL
export const DAPP_URL = APP_ENV === 'local' ? HTTP_DAPP_URL : 'https://' + SHORT_DAPP_URL

const SHORT_LANDING_URL = LANDING_URL_MAP[APP_ENV]
const HTTP_LANDING_URL = 'http://' + SHORT_LANDING_URL
export const LANDING_URL = APP_ENV === 'local' ? HTTP_LANDING_URL : 'https://' + SHORT_LANDING_URL

const SHORT_CLAIM_URL = CLAIM_URL_MAP[APP_ENV]
const HTTP_CLAIM_URL = 'http://' + SHORT_CLAIM_URL
export const CLAIM_URL = APP_ENV === 'local' ? HTTP_CLAIM_URL : 'https://' + SHORT_CLAIM_URL

export const NETWORK_URL = 'https://www.convergeonchain.xyz/'

const SHORT_CALCULATOR_URL = CALCULATOR_URL_MAP[APP_ENV]
const HTTP_CALCULATOR_URL = 'http://' + SHORT_CALCULATOR_URL
export const CALCULATOR_URL = APP_ENV === 'local' ? HTTP_CALCULATOR_URL : 'https://' + SHORT_CALCULATOR_URL

export const GITBOOK_URL = 'https://docs.ethena.fi'
export const TWITTER_URL = 'https://x.com/ethena_labs'
export const TELEGRAM_URL = 'https://t.me/ethena_labs'
export const GITHUB_URL = 'https://github.com/ethena-labs'
export const MIRROR_URL = 'https://mirror.xyz/0xF99d0E4E3435cc9C9868D1C6274DfaB3e2721341'
export const GOVERNANCE_URL = 'https://gov.ethenafoundation.com/'
export const DISCORD_URL = 'https://discord.gg/ethena'
export const CAREERS_URL = 'https://jobs.lever.co/ethenalabs/'
export const GENERAL_ENQUIRIES_URL = 'https://form.typeform.com/to/TgnUS2He'
export const LIQUID_LEVERAGE_LINK = 'https://app.defisaver.com/recipes/book?recipe=ethena-x-aave-liquid-leverage'
